const colors = {
  yellow: '#FFDF65',
  brightGold: '#F2BA52',

  brightCyan: '#3AAFA9',
  brightBlue: '#58B8ED',
  anchorBlue: '#3671BF',

  brightPink: '#FF008C',
  darkPink: '#D309E1',

  brightPurple: '#9C1AFF',
  veryLightPurple: '#C3C2F2',
  lightPurple: '#AAA7F2',
  purple: '#7D79D9',
  darkPurple: '#585699',
  veryDarkPurple: '#333259',

  black: '#000000',

  veryLightGray: '#E8E8DB',
  lightGray: '#D6D4CE',
  darkGray: '#969590',

  white: '#FFFFFF',
};

export default colors;
